import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "../../pages/Loader";
import Swal from "sweetalert2";

const AddGallery = () => {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoading(true); // if you're using a loading state

      const formData = new FormData();
      const photoFile = data.certificateImage[0];

      formData.append("file", photoFile);
      formData.append("upload_preset", "prayagproperties");

      const cloudinaryResponse = await fetch(
        "https://api.cloudinary.com/v1_1/djmyigser/image/upload",
        {
          method: "POST",
          body: formData,
        }
      );

      const cloudinaryData = await cloudinaryResponse.json();

      if (!cloudinaryData.secure_url) {
        throw new Error("Failed to upload image to Cloudinary");
      }

      // Send to your backend (use create_gallery endpoint here)
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/create_gallery`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: data.title,
          photo: cloudinaryData.secure_url,
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        Swal.fire({
          title: "Success!",
          text: "Gallery added successfully.",
          icon: "success",
          confirmButtonColor: "#2563eb",
        });

        reset(); // Clear form
      } else {
        Swal.fire({
          title: "Error",
          text: result.message || "Something went wrong.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "Something went wrong.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const imagePreview = watch("certificateImage");

  return (
    <div className="flex items-center justify-center min-h-[75vh] bg-gray-100">
      <div className="w-full max-w-2xl mx-auto p-6 bg-white rounded-2xl shadow-md">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Add New Gallery
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          {/* Title */}
          <div>
            <label className="block mb-1 font-medium">Title</label>
            <input
              type="text"
              {...register("title", { required: "Title is required." })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter Title"
            />
            {errors.title && (
              <p className="text-sm text-red-500 mt-1">
                {errors.title.message}
              </p>
            )}
          </div>

          {/* Image Upload */}
          <div>
            <label className="block mb-1 font-medium">Image</label>
            <input
              type="file"
              accept="image/*"
              {...register("certificateImage", { required: true })}
              className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200"
            />
            {errors.certificateImage && (
              <p className="text-sm text-red-500 mt-1">Image is required.</p>
            )}
            {/* Preview */}
            {imagePreview && imagePreview.length > 0 && (
              <img
                src={URL.createObjectURL(imagePreview[0])}
                alt="Preview"
                className="mt-3 w-32 h-32 object-cover rounded border"
              />
            )}
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm sm:text-base font-semibold py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
              disabled={loading}
            >
              {loading && (
                <Loader />
              )}
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGallery;
